module.exports = __webpack_public_path__ + "../resources/img/ic_re_info.5e4c5785.svg";